/**
 * Resolve the System API origin.
 *
 * Production (CRA `npm run build`): https://system-api.mafert.com unless
 * REACT_APP_SYSTEM_API_BASE_URL is set. Paths already include `/api/...`.
 * Local `npm start`: http://127.0.0.1:8081 unless the env var overrides.
 * App Platform production builds MUST set
 * REACT_APP_SYSTEM_API_BASE_URL=https://system-api.mafert.com.
 *
 * api.mafert.com is the MafertApp central API — never the System SPA base.
 * system.mafert.com is the System UI only — never the System API origin.
 *
 * Do not derive the API origin from window.location.
 */
const PRODUCTION_SYSTEM_API_ORIGIN = 'https://system-api.mafert.com';

export function resolveSystemApiBaseUrl(
  explicitEnv = process.env.REACT_APP_SYSTEM_API_BASE_URL,
  nodeEnv = process.env.NODE_ENV,
) {
  if (typeof explicitEnv === 'string' && explicitEnv.trim() !== '') {
    return explicitEnv.trim().replace(/\/$/, '');
  }

  if (nodeEnv === 'production') {
    return PRODUCTION_SYSTEM_API_ORIGIN;
  }

  // process.env.NODE_ENV is inlined by CRA so this local origin is dropped
  // from production bundles (no 127.0.0.1 in minified output).
  if (process.env.NODE_ENV !== 'production') {
    return 'http://127.0.0.1:8081';
  }

  return PRODUCTION_SYSTEM_API_ORIGIN;
}
